module.exports = __webpack_public_path__ + "static/map-bg-183520e7da021cdac27db335c64e7dc5.jpg";